<template>
  <div style="margin-top: 25px; margin-bottom: 100px">
    <v-dialog v-model="company_dialog" width="500" persistent>
      <v-card
        style="position: relative; padding-bottom: 20px"
        min-height="250"
        width="500"
      >
        <v-toolbar flat>
          <v-toolbar-title style="font-weight: bold">{{
            action == "edit" ? "Edit Company" : "Create Company"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="grey" dark @click="cancel_company_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          class="ma-5 overflow-y-auto"
          style="text-align: left; max-height: 450px"
        >
          <v-form ref="form">
            <div>
              <p style="font-weight: bold">Company ID:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_company_id"
                  single-line
                  outlined
                  :readonly="action == 'edit'"
                  dense
                  @input="clear_error_message('company_id')"
                  :error-messages="company_id_error_message"
                  :rules="[
                    () => !!selected_company_id || 'Company ID is required',
                    () =>
                      selected_company_id.length >= 5 ||
                      'At least 5 characters',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Company Name:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_company_name"
                  single-line
                  outlined
                  dense
                  :readonly="!isEditor"
                  :rules="[
                    () => !!selected_company_name || 'Company Name is required',
                    () =>
                      selected_company_name.length >= 5 ||
                      'At least 5 characters',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <p style="font-weight: bold">Company Receiver Email:</p>
              <ColMoreTextField
                :is_required="true"
                :value="email_receiver_list"
                placeholder="Email"
                :multiple="true"
                @update_start_time_value="update_start_time_value($event)"
                @remove_date_time="remove_date_time($event)"
                @add_date_time="add_date_time($event)"
              ></ColMoreTextField>
            </div>
            <div v-if="current_user_company_doc_id == ''">
              <v-col cols="12">
                <v-row>
                  <p style="font-weight: bold">Multi Tier Commission:</p>
                  <v-spacer></v-spacer>
                  <v-switch
                    style="margin-top: -5px"
                    v-model="selected_commission_enable"
                    inset
                  ></v-switch>
                </v-row>
              </v-col>
            </div>
            <div v-if="selected_commission_enable">
              <p style="font-weight: bold">Commission Release Date:</p>
              <v-combobox
                v-model="selected_commission_release_date_list"
                :items="day_list"
                single-line
                outlined
                :readonly="!isEditor"
                multiple
                dense
                :rules="[
                  () =>
                    selected_commission_release_date_list.length > 0 ||
                    'Release Date is required',
                ]"
              ></v-combobox>
            </div>
          </v-form>
        </div>
        <v-card-actions>
          <v-btn
            color="primary"
            class="white--text"
            block
            depressed
            style="text-transform: capitalize"
            @click="update_company"
            :loading="is_submitting"
            :disabled="is_submitting"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="company_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          @click:row="view_company"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Company"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="current_user_company_doc_id == ''">
                <v-btn
                  depressed
                  color="primary"
                  dark
                  style="text-transform: capitalize"
                  @click="open_company_dialog"
                >
                  <v-icon left dark> mdi-plus </v-icon>
                  Create Company
                </v-btn>
              </div>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import ColMoreTextField from "./ColMoreTextField.vue";

export default {
  components: {
    ColMoreTextField,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Company ID",
          value: "company_id",
          sortable: true,
          divider: true,
        },
        { text: "Company Name", value: "company_name", divider: true },
        {
          text: "Number of Operators",
          value: "company_users",
          sortable: true,
          divider: true,
        },
        {
          text: "Multi Tier Commission",
          value: "is_commission_enable",
          sortable: true,
          divider: true,
        },
      ],
      company_list: [],
      table_loading: false,
      search: "",
      action: "",
      company_id_error_message: "",
      selected_company_id: "",
      selected_company_name: "",
      selected_commission_enable: false,
      commission_enable_list: ["disabled", "enabled"],
      day_list: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      selected_commission_release_date_list: [],
      email_receiver_list: [],
      company_dialog: false,
      is_submitting: false,

      current_user_permission: [],
      current_user_company_doc_id: "",
      isEditor: false,
    };
  },
  methods: {
    update_start_time_value(value) {
      const time = value.time;
      const index = value.index;
      if (index > -1) {
        this.email_receiver_list[index].email = time;
        // this.email_receiver_list[index].error_message = "";
      }
    },
    remove_date_time(value) {
      this.email_receiver_list.splice(value, 1);
    },
    add_date_time(value) {
      this.email_receiver_list.push({
        email: "",
        error_message: "",
      });
    },
    async create_company() {
      this.is_submitting = true;
      var result = await this.validate_duplication(["company_id"]);
      if (result) {
        // create user
        var email_list = this.email_receiver_list.map(function (item) {
          return item["email"];
        });

        var response = await this.send_http_request("companySignUp", {
          company_name: this.selected_company_name,
          company_id: this.selected_company_id,
          is_commission_enable: this.selected_commission_enable,
          email_receiver: email_list,
          commission_release_date_list:
            this.selected_commission_release_date_list,
        });
        if (response.data.status == "OK") {
          this.is_submitting = false;
          this.cancel_company_dialog();
          this.load_company();
          this.show_snack_bar("success", "Company Created");
        } else {
          this.is_submitting = false;
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.is_submitting = false;
      }
    },
    async edit_company() {
      this.is_submitting = true;
      // edit user
      var email_list = this.email_receiver_list.map(function (item) {
        return item["email"];
      });

      var response = await this.send_http_request("updateCompanyInfo", {
        company_id: this.selected_company_id,
        company_name: this.selected_company_name,
        is_commission_enable: this.selected_commission_enable,
        email_receiver: email_list,
        commission_release_date_list:
          this.selected_commission_release_date_list,
      });
      if (response.data.status == "OK") {
        this.is_submitting = false;
        this.cancel_company_dialog();
        this.load_company();
        this.show_snack_bar("success", "Company Updated");
      } else {
        this.is_submitting = false;
        this.show_snack_bar("error", "Something went wrong");
      }
    },
    update_company() {
      if (this.$refs.form.validate()) {
        if (this.action == "create") {
          this.create_company();
        } else {
          this.edit_company();
        }
      }
    },
    clear_error_message(type) {
      if (type == "company_id") {
        this.company_id_error_message = "";
      }
    },
    cancel_company_dialog() {
      this.selected_company_id = "";
      this.selected_company_name = "";
      this.company_id_error_message = "";
      this.selected_commission_enable = false;
      this.selected_commission_release_date_list = [];
      this.email_receiver = [];

      this.company_dialog = false;
      this.$refs.form.resetValidation();
    },
    load_company() {
      this.table_loading = true;
      this.send_http_request("getAllCompaniesWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.company_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    view_company(value) {
      this.action = "edit";
      this.selected_company_id = value.company_id;
      this.selected_company_name = value.company_name;
      this.selected_commission_enable = value.is_commission_enable;
      this.email_receiver_list = [];
      if (value.email_receiver == null || value.email_receiver.length == 0) {
        this.email_receiver_list = [{ email: "" }];
      } else {
        value.email_receiver.forEach((email) => {
          this.email_receiver_list.push({ email: email });
        });
      }
      this.selected_commission_release_date_list =
        value.commission_release_date_list == undefined
          ? []
          : value.commission_release_date_list;
      this.company_dialog = true;
    },
    open_company_dialog() {
      this.action = "create";
      this.company_dialog = true;
      this.email_receiver_list = [{ email: "" }];
    },
    validate_duplication(required_validation_list) {
      return new Promise((res, rej) => {
        var promises = [];

        if (required_validation_list.includes("company_id")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsCompanyIdTaken", {
                company_id: this.selected_company_id,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.company_id_error_message = "Company ID has been taken";
                  } else {
                    this.company_id_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }

        Promise.all(promises)
          .then(() => {
            res(this.company_id_error_message == "");
          })
          .catch((error) => {
            rej(error);
          });
      });
    },
  },
  mounted() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    this.load_company();
    this.isEditor =
      this.current_user_company_doc_id == "" ||
      (this.current_user_company_doc_id != "" &&
        (this.current_user_permission.includes("Wbl2TAMLlfwkX8QDwztB") ||
          this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")));
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>